import React from 'react'
import { withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import NameBlock from '../NameBlock/NameBlock'
import AttributeBlock from '../AttributeBlock/AttributeBlock'
import VersionBlock from '../VersionBlock/VersionBlock'
import DeleteBotBlock from '../DeleteBotBlock/DeleteBotBlock'
import ContextualConversationsBlock from '../ContextualConversationsBlock'

import { styles } from './styles'
import { hasPermissionForFeature } from '../../../../../security'
import { isQcsBot } from '../../../../../constants/qcs'

const General = ({ classes, activeBot }) => {
  const canDeleteBot = hasPermissionForFeature('deleteBot', activeBot?.id)
  const isQcs = isQcsBot(activeBot)

  return (
    <div className={classes.container}>
      <NameBlock />
      {!isQcs && <AttributeBlock />}
      {!isQcs && <VersionBlock />}
      {!isQcs && <ContextualConversationsBlock />}
      {canDeleteBot && !isQcs && <DeleteBotBlock />}
    </div>
  )
}

General.propTypes = {
  classes: PropTypes.object,
  activeBot: PropTypes.object,
}

const mapStateToProps = (state) => ({
  activeBot: state.activeBot,
})

export default connect(mapStateToProps)(withStyles(styles)(General))
